import { useLocation } from 'react-router-dom'

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

/**
 * @deprecated The method should not be used. Please use useQueryParams instead.
 */
const useUrlQueryParam = (param: string) => {
  let query = useQuery()
  return query.get(param)
}

export default useUrlQueryParam
